import { useState } from 'react';
import { useLang } from '../LangContext';

const WA_NUMBER = '918127356940';

export default function Contact() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: '', phone: '', message: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const text = `Hello Kids Play Hall! 👋\n\n*Name:* ${form.name}\n*Phone:* ${form.phone}\n*Message:* ${form.message}`;
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="contact" className="contact">
      <span className="section-tag center">{t.contactTag}</span>
      <h2 className="section-title">{t.contactTitle}</h2>
      <p className="section-subtitle">{t.contactSub}</p>

      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>{t.formTitle}</h3>
          <input type="text" name="name" placeholder={t.formName} required value={form.name} onChange={handleChange} />
          <input type="tel" name="phone" placeholder={t.formPhone} required value={form.phone} onChange={handleChange} />
          <textarea name="message" placeholder={t.formMsg} rows="5" required value={form.message} onChange={handleChange} />
          <button type="submit" className="btn-whatsapp">
            <span>{t.formBtn}</span>
            <svg width="22" height="22" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="16" fill="#25D366"/>
              <path d="M23.5 8.5A10.44 10.44 0 0 0 16 5.5C10.2 5.5 5.5 10.2 5.5 16c0 1.85.48 3.65 1.4 5.24L5.5 26.5l5.4-1.38A10.46 10.46 0 0 0 16 26.5c5.8 0 10.5-4.7 10.5-10.5 0-2.8-1.09-5.43-3-7.5zm-7.5 16.15a8.7 8.7 0 0 1-4.44-1.22l-.32-.19-3.2.82.85-3.1-.2-.33A8.7 8.7 0 0 1 7.3 16c0-4.8 3.9-8.7 8.7-8.7 2.32 0 4.5.9 6.14 2.55A8.64 8.64 0 0 1 24.7 16c0 4.8-3.9 8.65-8.7 8.65zm4.77-6.5c-.26-.13-1.54-.76-1.78-.85-.24-.09-.41-.13-.58.13-.17.26-.65.85-.8 1.02-.15.17-.3.2-.56.07-.26-.13-1.1-.4-2.1-1.28-.77-.69-1.3-1.54-1.45-1.8-.15-.26-.02-.4.11-.53.12-.12.26-.3.39-.46.13-.16.17-.26.26-.43.09-.17.04-.32-.02-.45-.07-.13-.58-1.4-.8-1.92-.2-.5-.42-.43-.58-.44h-.5c-.17 0-.45.06-.69.32-.24.26-.9.88-.9 2.14s.92 2.48 1.05 2.65c.13.17 1.8 2.75 4.37 3.86.61.26 1.09.42 1.46.54.61.2 1.17.17 1.61.1.49-.07 1.54-.63 1.76-1.24.22-.6.22-1.12.15-1.23-.06-.1-.23-.16-.5-.3z" fill="white"/>
            </svg>
          </button>
        </form>

        <div className="contact-info">
          <h3>{t.findUs}</h3>
          <div className="info-item">📍 <span>{t.footerAddress}</span></div>
          <div className="info-item">📞 <span><a href="tel:+918127356940" style={{ color: 'inherit', textDecoration: 'none' }}>+91 81273 56940</a></span></div>
          <div className="info-item">✉️ <span>kidsplayhall.16125@gmail.com</span></div>
          <div className="info-item">🕐 <span>{t.hours}</span></div>
          <div className="map-embed">
            <iframe
              title="Kids Play Hall Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1115.1137282445115!2d81.74654326691397!3d25.637115745169513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399ac59a4a5400f1%3A0xa660b7ed259f11!2sIthunt!5e1!3m2!1sen!2sin!4v1775483467991!5m2!1sen!2sin"
              width="100%" height="200" style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen="" loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
